<template>
  <span
    v-if="value !== undefined"
    class="resulticon"
    :class="getColor"
  >
    {{ getText }}
    <div class="toggle-tooltip">
      {{ getTextToolTip }}
    </div>
  </span>
</template>

<script>
export default {
  props: {
    value: String,
  },
  computed: {
    getColor: function() {
      const isRed = this.value !== undefined && this.value.includes("RED");
      return isRed ? "o1" : "o2";
    },
    getText: function() {
      const isRed = this.value !== undefined && this.value.includes("RED");
      return isRed ? "Đ" : "X";
    },
    getTextToolTip: function() {
      const isRed = this.value !== undefined && this.value.includes("RED");
      return isRed ? "Đỏ" : "Xanh";
    },
  },
}
</script>

